//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src

import { mapState } from 'vuex'
export default {
  name: 'CustomerList',
  data() {
    return {
      loadType: ''
    }
  },
  props: [
    'getSession',
    'doctorId',
    'sessionId',
    'sendMessage',
    'type',
    'list',
    'close'
  ],
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
  },
  methods: {
    clearDoctor () {
      this.$store.httpDispatch({})('putSessionDoctor', {
        sessionId: this.sessionId,
        to: ''
      }).then((res) => {
        if (res.data.code === 0) {
          this.sendMessage('alert', `已將醫生移出會話。`)
          this.getSession()
          this.close()
        }
      })
    },
    putSession(to, nickname) {
      if (this.type === 'doctor') {
        this.putSessionDoctor(to, nickname)
      } else if (this.type === 'customer') {
        this.putSessionCustomer(to, nickname)
      }
    },
    putSessionDoctor (to, nickname) {
      this.$store.httpDispatch({})('putSessionDoctor', {
        sessionId: this.sessionId,
        to: to
      }).then((res) => {
        if (res.data.code === 0) {
          this.getSession()
          this.sendMessage('alert', `您的咨詢已經轉給${nickname}醫生，醫生最遲將在2小時內為您解答，請留意公眾號消息。`)
          this.close()
        }
      })
    },
    putSessionCustomer (to, nickname) {
      this.$store.httpDispatch({})('putSessionCustomer', {
        sessionId: this.sessionId,
        to: to
      }).then((res) => {
        if (res.data.code === 0) {
          this.getSession()
          this.sendMessage('alert', `您的咨詢已經轉給${nickname}，${nickname}將繼續為您服務。`)
          this.close()
          window.alert('轉接成功，請關閉聊天')
        }
      })
    }
  }
}
